import { stringToSlug } from "../../utils/string";

export const createKeyHandler = () => {
	const keys: Array<string> = [];
	return (heading: string) => {
		const name = stringToSlug(heading);
		let i = 1;
		while (keys.includes(`${name}-${i}`)) {
			i += 1;
		}
		keys.push(`${name}-${i}`);
		return `${name}-${i}`;
	};
};
